import React from "react";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { useTranslation } from "react-i18next";
import CopyLinkWithoutBackground from "../../iFrame/copyLinkWithoutBackground";

const EmptyCart = ({ isCartSource, productsLength }) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-center w-full gap-1 lg:gap-4">
      <div className="flex items-center justify-center">
        <XMarkIcon className="w-5 h-5 me-1" />
        <span className="font-medium text-black lg:text-xl">{t("CartEmpty")}</span>
      </div>
      
      {(!isCartSource || productsLength === 0) && (
        <CopyLinkWithoutBackground />
      )}
    </div>
  );
};

export default EmptyCart;